import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import alert from '../../../assets/images/alert.svg';
import { ErrorType } from '../../../env/constants/errors';
import useAppStateData from '../../../redux/hooks/useAppStateData';
import Optional from '../../hoc/Optional';

const DisplayValidationErrors: React.FC = () => {
    const { errorMessage: errorReason, validationErrorCounter } = useAppStateData();

    useEffect(() => {
        datadogRum.addError(new Error(ErrorType.VALIDATION_ERROR), {
            type: ErrorType.VALIDATION_ERROR,
            reason: errorReason,
        });
    }, [errorReason, validationErrorCounter]);

    return (
        <Optional renderIf={errorReason}>
            <div data-testid="error-container" className="validation-form__error-container">
                <div data-testid="alert-icon-container" className="validation-form__alert-icon-container">
                    <img data-testid="alert-icon" src={alert} alt="alert icon" />
                </div>
                <div data-testid="error-text" className="validation-form__error-text">
                    <div>
                        <div>We can&apos;t find a match for that claim number and zip code combination.</div>
                        <div>Please try again.</div>
                    </div>
                </div>
            </div>
        </Optional>
    );
};

export default DisplayValidationErrors;
